export default __webpack_public_path__ + "static/media/32casinoCardsHin.130b373e.jpg";